import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import registerBeforeHooks from './before'

Vue.use(VueRouter)

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    const handlePaceCallback = (matched) => {
      if (typeof matched.meta.pace === 'function') {
        return matched.meta.pace(to, from)
      }

      return matched.meta.pace
    }

    if (to.matched.some(route => handlePaceCallback(route) === false)) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  }
})

registerBeforeHooks(router)

// Export the router so we can import it into our App component.
export default router
